/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { CloudDownload } from "lucide-react";
import { useGetImage } from "utils/apis/lookups.api";
import { Button } from "@repo/ui";
import { showToast } from "utils/helper";

function AttachmentsDownloadGrid({ data }: any) {
  function DownloadButtonCell({ dataItem }: any) {
    const {
      data: response,
      mutate: getImage,
      isPending,
      isError,
      reset,
    } = useGetImage();

    useEffect(() => {
      if (response) {
        const imageUrl = URL.createObjectURL(response as Blob);
        // Open the image in a new tab for preview
        // window.open(imageUrl, "_blank");

        // Create a hidden anchor element to trigger the download
        const link = document.createElement("a");
        link.href = imageUrl;
        link.download = dataItem.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        reset();
      }
      if (isError) {
        showToast(
          "error",
          "The resource you are trying to download was not found."
        );
        reset();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [response, isError]);

    return (
      <td className="text-center">
        <Button
          variant="link"
          className="w-full"
          disabled={isPending}
          onClick={() => {
            getImage(dataItem.filePath as string);
          }}
        >
          <CloudDownload className="mx-auto" />
        </Button>
      </td>
    );
  }

  return (
    <Grid data={data}>
      <GridColumn field="fileName" title="File Name" />
      <GridColumn
        width={120}
        title="Download"
        cell={DownloadButtonCell}
        className="text-centre mt-2"
      />
    </Grid>
  );
}

export default React.memo(AttachmentsDownloadGrid);
